/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20ResponseDefinition } from '../../openapi/v2/models/Oas20ResponseDefinition';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';

/**
 * A command used to replace a response definition with a newer version.
 * @author eric.wittmann@gmail.com
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplaceResponseDefinitionCommand_20 extends ReplaceNodeCommand<Oas20ResponseDefinition> {
    public _defName : string;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>Oas20ResponseDefinition) || old === null) && ((replacement != null && replacement instanceof <any>Oas20ResponseDefinition) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
            if(this._defName===undefined) this._defName = null;
            if(this._defName===undefined) this._defName = null;
            (() => {
                this._defName = old.getName();
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._defName===undefined) this._defName = null;
            if(this._defName===undefined) this._defName = null;
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v2_models_Oas20ResponseDefinition(doc : Document, node : Oas20ResponseDefinition) {
        let doc20 : Oas20Document = <Oas20Document>doc;
        doc20.responses.removeResponse(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#removeNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Oas20ResponseDefinition} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Oas20ResponseDefinition) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v2_models_Oas20ResponseDefinition(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v2_models_Oas20ResponseDefinition(doc : Document, node : Oas20ResponseDefinition) {
        let doc20 : Oas20Document = <Oas20Document>doc;
        node._ownerDocument = doc20;
        node._parent = doc20.responses;
        doc20.responses.addResponse(node.getName(), node);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#addNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Oas20ResponseDefinition} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Oas20ResponseDefinition) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v2_models_Oas20ResponseDefinition(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Oas20ResponseDefinition}
     */
    readNode(doc : Document, node : any) : Oas20ResponseDefinition {
        let doc20 : Oas20Document = <Oas20Document>doc;
        let definition : Oas20ResponseDefinition = doc20.responses.createResponse(this._defName);
        Library.readNode(node, definition);
        return definition;
    }
}
ReplaceResponseDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceResponseDefinitionCommand_20";
ReplaceResponseDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




